/*
 * SpaceX-style header fade: quick fade out on scroll down, quick fade back
 * in on scroll up (or near the top). Rides on top of Horizon's sticky
 * header ('always') — we only touch opacity via a class.
 *
 * Horizon scrolls .page-wrapper on desktop but the document on mobile, so
 * listen to both and read whichever actually moved.
 */
(() => {
  const headerSection = document.querySelector('.header-section');
  if (!headerSection) return;

  const pageWrapper = document.querySelector('.page-wrapper');
  const readTop = () =>
    Math.max(
      window.scrollY || 0,
      document.scrollingElement ? document.scrollingElement.scrollTop : 0,
      pageWrapper ? pageWrapper.scrollTop : 0
    );

  let last = readTop();
  let ticking = false;

  function update() {
    ticking = false;
    const y = readTop();
    const delta = y - last;
    if (Math.abs(delta) < 2) return;

    if (y < 60 || delta < 0) {
      headerSection.classList.remove('header-faded');
    } else {
      headerSection.classList.add('header-faded');
    }
    last = y;
  }

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  if (pageWrapper) pageWrapper.addEventListener('scroll', onScroll, { passive: true });
})();
